<template>
  <div class="container">
    <div id="login" class="row justify-content-centre">
      <p class="padding col-sm-6">
          Enter your email address and the password that's contained in the book.
      </p>

      <Credentials/>
    </div>
  </div>
</template>

<script>
import Credentials from '@/components/CredentialsForm.vue'
export default {
  name: 'Login',

  components: {
    Credentials
  },

  data () {
    return {
    }
  }
}
</script>

<style lang="css" scoped>
  ul, li{
    list-style:none;
  }
</style>
